import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { Player } from '@lottiefiles/react-lottie-player';
import { cn } from '@/utils/styles';
import { TrackingSampleModal } from '../screens/HomePage/components/TrackingSampleModal';
import { useState } from 'react';

interface ResultsPendingProps {
  title: string;
  videoSrc?: any;
  dark?: boolean;
  className?: string;
  'data-testid'?: string;
}

export const ResultsPending = ({
  title,
  videoSrc,
  className,
  dark = false,
  'data-testid': testId,
}: ResultsPendingProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={cn(
          'flex items-center justify-center h-full',
          dark ? 'bg-black' : 'bg-white',
        )}
        data-testid={testId}
      >
        <div className="text-center max-w-72" data-testid="resultsPending-content">
          {/* TODO: ADD Onclick func to sample tracker */}
          <div>
            <div className="mb-9 w-full h-full" data-testid="resultsPending-video">
              <Player autoplay loop src={videoSrc} />
            </div>

            <h1 className={cn('typography-h1 text-secondary mb-9', className)} data-testid="resultsPending-title">
              {title}
            </h1>

            <div
              className="flex justify-center cursor-pointer"
              onClick={() => setIsModalOpen(true)}
              data-testid="resultsPending-trackProgress"
            >
              <p className={cn('typography-body text-tertiary', className)}>
                Track your kit's progress
              </p>
              <ChevronRightIcon className={cn('text-tertiary', className)} />
            </div>
          </div>
        </div>
      </div>
      <TrackingSampleModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
